// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TcsWrapperModelsClaimModel } from './tcsWrapperModelsClaimModel.js';
import type { TcsWrapperModelsMedicationModel } from './tcsWrapperModelsMedicationModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TcsWrapperModelsClaimAccumulatorModel {
    'claims'?: Array<TcsWrapperModelsClaimModel>;
    'medications'?: Array<TcsWrapperModelsMedicationModel>;
    'medicationMaxBenefit'?: number;
    'remainingMedicationBenefit'?: number;
    'totalMedicationPaid'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TcsWrapperModelsClaimAccumulatorModel>> = [
        {
            "name":     "claims",
            "baseName": "claims",
            "type":     "Array<TcsWrapperModelsClaimModel>"
        },
        {
            "name":     "medications",
            "baseName": "medications",
            "type":     "Array<TcsWrapperModelsMedicationModel>"
        },
        {
            "name":     "medicationMaxBenefit",
            "baseName": "medicationMaxBenefit",
            "type":     "number"
        },
        {
            "name":     "remainingMedicationBenefit",
            "baseName": "remainingMedicationBenefit",
            "type":     "number"
        },
        {
            "name":     "totalMedicationPaid",
            "baseName": "totalMedicationPaid",
            "type":     "number"
        },
    ];

    static getAttributeTypeMap() {
        return TcsWrapperModelsClaimAccumulatorModel.attributeTypeMap;
    }
}
